import { createSlice } from "@reduxjs/toolkit";
import { setAuthorisedUser } from "./AppReducer";
import { ownedUserIds, belongsToSomeoneElse, isStaffProfile } from "../ownership";

const initialState = {
  creatingEmployeeBasicData: null,
  creatingEmployeeI9ManualData: null,
  creatingEmployeeI9ListBManualData: null,
  creatingEmployeeI9ListCManualData: null,
  employeeDocumentesListOptions: null,
  isEmployeeDetailsExists: false,
  employeeListBAnalyseDetails: null,
  employeeListCAnalyseDetails: null,
  isAddDocumentForListBandCOpen: false,
  createdEmployeeDraft: null,
  isSelectingListCDoc: false,
  priorI9Forms: [],
};

const EmployeeSlice = createSlice({
  name: "Employee",
  initialState,
  reducers: {
    setCreatingEmployeeBasicData: (state, actions) => {
      state.creatingEmployeeBasicData = actions.payload;
    },
    setCreatingEmployeeI9ManualData: (state, actions) => {
      state.creatingEmployeeI9ManualData = actions.payload;
    },
    setCreatingEmployeeI9ListBManualData: (state, actions) => {
      state.creatingEmployeeI9ListBManualData = actions.payload;
    },
    setCreatingEmployeeI9ListCManualData: (state, actions) => {
      state.creatingEmployeeI9ListCManualData = actions.payload;
    },
    setEmployeeDocumentesListOptions: (state, actions) => {
      state.employeeDocumentesListOptions = actions.payload;
    },
    setIsEmployeeDetailsExists: (state, actions) => {
      state.isEmployeeDetailsExists = actions.payload;
    },
    setEmployeeListBAnalyseDetails: (state, actions) => {
      state.employeeListBAnalyseDetails = actions.payload;
    },
    setEmployeeListCAnalyseDetails: (state, actions) => {
      state.employeeListCAnalyseDetails = actions.payload;
    },
    setIsAddDocumentForListBandCOpen: (state, actions) => {
      state.isAddDocumentForListBandCOpen = actions.payload;
    },
    setCreatedEmployeeDraft: (state, actions) => {
      state.createdEmployeeDraft = actions.payload;
    },
    setIsSelectingListCDoc: (state, actions) => {
      state.isSelectingListCDoc = actions.payload;
    },
    setPriorI9Forms: (state, actions) => { 
      state.priorI9Forms = actions.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setAuthorisedUser, (state, action) => {
      const owned = ownedUserIds(action.payload);
      const staff = isStaffProfile(action.payload);
      const ownsNone = (data) =>
        !staff &&
        belongsToSomeoneElse(
          owned,
          data?.userI9Details?.userId ?? data?.userDocuments?.[0]?.userId
        );
      if (ownsNone(state.creatingEmployeeI9ManualData)) {
        state.creatingEmployeeI9ManualData = null;
      }
      if (ownsNone(state.creatingEmployeeI9ListBManualData)) {
        state.creatingEmployeeI9ListBManualData = null;
      }
      if (ownsNone(state.creatingEmployeeI9ListCManualData)) {
        state.creatingEmployeeI9ListCManualData = null;
      }
      if (belongsToSomeoneElse(owned, state.creatingEmployeeBasicData?.userId)) {
        state.creatingEmployeeBasicData = null;
      }
    });
  },
});

export const {
  setCreatingEmployeeBasicData,
  setCreatingEmployeeI9ManualData,
  setCreatingEmployeeI9ListBManualData,
  setCreatingEmployeeI9ListCManualData,
  setEmployeeDocumentesListOptions,
  setIsEmployeeDetailsExists,
  setEmployeeListBAnalyseDetails,
  setEmployeeListCAnalyseDetails,
  setIsAddDocumentForListBandCOpen,
  setCreatedEmployeeDraft,
  setIsSelectingListCDoc,
  setPriorI9Forms, 
} = EmployeeSlice.actions;

export default EmployeeSlice.reducer;